import { connect } from 'react-redux';
import ListaBoletos from './listaBoletos';

export default connect()(ListaBoletos);
